exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#games-page[data-v-0cfcdaff]{background:#000}iframe[data-v-0cfcdaff]{width:100%;height:700px}", ""]);

// exports
